'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Extra info blocks from Destextrainfo in DB.
var WinresDestinationBlocks = function () {
    function WinresDestinationBlocks($scope, $filter, $sce) {
        _classCallCheck(this, WinresDestinationBlocks);

        this.$scope = $scope;
        this.$filter = $filter;
        this.$sce = $sce;
        this.blocks = [];
    }

    _createClass(WinresDestinationBlocks, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination

            this.data = this.winresReservationContext.getContext();
            this.$scope.$watch('$ctrl.data.Destination', function () {
                if (!_this.data.Destination) {
                    return;
                }

                _this.blocks = _.cloneDeep(_this.data.Destination.WebSiteInformationBlocks);

                // What's this?
                // this.blocks.forEach(block => {
                //     block.Text = this.$filter('linky')(block.Text).replaceAll("&#10;", "</p><p>");
                // });

                _this.filterByIcon();
            });
        }

        // code: 0 = clock-o, 1 = calendar, 2 = car, 3 = bike, 4 = globe, 5 = info-circle, 6 = wheelchair, 7 = train

    }, {
        key: 'filterByIcon',
        value: function filterByIcon() {
            var _this2 = this;

            this.infoBlocks = [[], [], [], [], [], [], [], [], [], [], []];
            _.forEach(this.blocks, function (block) {
                if (block.Icon == "clock-o") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[0].push(block);
                } else if (block.Icon == "calendar") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[1].push(block);
                } else if (block.Icon == "car") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[2].push(block);
                } else if (block.Icon == "bicycle") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[3].push(block);
                } else if (block.Icon == "globe") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[4].push(block);
                } else if (block.Icon == "info-circle") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[5].push(block);
                } else if (block.Icon == "wheelchair") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[6].push(block);
                } else if (block.Icon == "train") {
                    _this2.infoBlocks[7].push(block);
                } else if (block.Icon == "money") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[8].push(block);
                } else if (block.Icon == "bus") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[9].push(block);
                } else if (block.Icon == "ticket") {
                    block.Text = "<p>" + block.Text + "</p>";
                    _this2.infoBlocks[10].push(block);
                }
                block.Title = _this2.$sce.trustAsHtml(block.Title);
                block.Text = _this2.$sce.trustAsHtml(block.Text);
            });

            //console.log("blocks", this.blocks);
        }
    }]);

    return WinresDestinationBlocks;
}();

WinresDestinationBlocks.$inject = ['$scope', '$filter', '$sce'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'destination-blocks-default';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('destination-blocks-default', require('./winresDestinationBlocks.html'));
}]);

_module3.default.component('winresDestinationBlocks', {
    templateUrl: getTemplate,
    controller: WinresDestinationBlocks,
    bindings: {
        map: '@', // if true shows map on page
        divideByIcon: '@' //0 = clock-o, 1 = calendar, 2 car, 3 = bicycle, 4 = globe, 5 = info-circle, 6 = wheelchair, 7 = train (Does not have the <p> tags added)
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDestinationBlocks/winresDestinationBlocks.js
// module id = 425
// module chunks = 2